import { FC } from 'react';
import { Typography, Grid } from '@mui/material';
import { useHistory } from 'react-router-dom';
import palette from '../../theme/palette';
import HeroImg from '../../assets/images/home2.jpg';
import RespectImg from '../../assets/images/respect2.jpg';
import HumanCanineImg from '../../assets/images/humanAndCanine.jpeg';
import WorkingDogImg from '../../assets/images/workingDogs.png';
import AllieImg from '../../assets/images/static/allie-stormy-overlook.jpg';
import ScrollToTop from '../utils/ScrollToTop';

export const Home: FC = () => {
  const history = useHistory();

  return (
    <>
      <ScrollToTop />
      <Grid container sx={{ width: '100%', height: '100%' }}>
        <Grid
          item
          xs={12}
          sx={{
            margin: '70px 0',
            width: '100%',
            height: 'auto',
            minHeight: '75vh',
            backgroundImage: `url(${HeroImg})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-end',
          }}
        />
        <Grid
          item
          md={12}
          container
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <Grid
            item
            sm={12}
            md={6}
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img
              src={RespectImg}
              alt="Respect"
              style={{
                maxWidth: '100%',
                height: 'auto',
                objectFit: 'contain',
              }}
            />
          </Grid>
          <Grid
            item
            sm={12}
            md={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              padding: { xs: '16px', md: '50px' },
            }}
          >
            <Typography variant="h4">A PLACE OF RESPECT</Typography>
            <Typography variant="h5">
              The foundation of all of our curriculum is built on, First: the respect for the animal
              we have the privilege of working with, and Second: the people who love their animals
              enough to seek help to do what is best for them. Respect is not self-righteous or
              judgmental. We seek to compassionately provide truthful and LIMA-forward information
              to anyone willing to learn. The appropriate attitude, based in respect, towards the
              dogs is always on the forefront; never to be sacrificed for sales, marketing, or to
              satisfy a quick fix.
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          md={12}
          container
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <Grid
            item
            sm={12}
            md={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'right',
              padding: { xs: '16px', md: '50px' },
            }}
          >
            <Typography variant="h4">HUMAN and CANINE</Typography>
            <Typography variant="h5">
              Our focus is to work for you and your dog(s), building realistic and reliable training
              plans that educate you as the handler, helping you and your dog overcome barriers
              preventing you from enjoying each other freely.
            </Typography>
          </Grid>
          <Grid
            item
            sm={12}
            md={6}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img
              src={HumanCanineImg}
              alt="Human and Canine"
              style={{
                maxWidth: '100%',
                height: 'auto',
                objectFit: 'contain',
                transform: 'scaleX(-1)',
              }}
            />
          </Grid>
        </Grid>
        <Grid
          item
          md={12}
          container
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: '50px',
          }}
        >
          <Grid
            item
            md={6}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img
              src={WorkingDogImg}
              alt="Working Dog"
              style={{
                maxWidth: '100%',
                height: 'auto',
                objectFit: 'contain',
              }}
            />
          </Grid>
          <Grid
            item
            md={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              padding: { xs: '16px', md: '50px' },
            }}
          >
            <Typography variant="h4">
              PUPPY REARING, to SEVERE AGGRESSION, to WORKING DOGS
            </Typography>
            {/* <Typography variant="h5">
              I will walk side by side with you and your pack, to offer ongoing support and
              consultation.
            </Typography> */}
          </Grid>
        </Grid>
        <Grid
          item
          container
          sx={{
            backgroundColor: palette.paper.secondary,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
          onClick={() => history.push('/about')}
        >
          <Grid
            item
            sm={12}
            md={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              color: palette.text.contrast,
              padding: { xs: '16px', md: '50px' },
            }}
          >
            <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: '30px' }}>
              GET TO KNOW ALLIE
            </Typography>
            <Typography variant="h6">
              I am the owner of Rogue K9 Academy. I am a Certified Foundation Style Dog Trainer and
              have been working with and training animals for 30 years. My passion is teaching
              people how to work with their strong temperament and/or aggressive dogs, without
              vilifying them...
            </Typography>
          </Grid>
          <Grid item sm={12} md={6} sx={{ display: 'flex', justifyContent: 'center' }}>
            <img src={AllieImg} style={{ height: '100%', width: '100%' }} alt="Allie" />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Home;
